import { Box, BoxProps, Grid2 as Grid, styled, useTheme } from '@mui/material'
import React, { useMemo } from 'react'

const StyledBox = styled(Box)(() => ({
  maxWidth: 'calc(80% - 10px)',
  padding: '8px 10px',
  borderRadius: '8px',
  overflowWrap: 'anywhere'
}))

interface MessageBoxProps extends BoxProps {
  isSender: boolean
}

const MessageBox: React.FC<MessageBoxProps> = ({
  isSender,
  sx,
  ...boxProps
}) => {
  const theme = useTheme()
  const customStyle: BoxProps['sx'] = useMemo(
    () =>
      isSender
        ? {
            ...sx,
            boxShadow: `inset 0px 0px 5px ${theme.palette.primarySoft.main}`,
            backgroundColor: theme.palette.background.default,
            borderTopRightRadius: '0px',
            color: theme.palette.primarySoft.main
          }
        : {
            ...sx,
            backgroundColor: theme.palette.primarySoft.main,
            borderTopLeftRadius: '0px',
            color: theme.palette.primarySoft.contrastText
          },
    [isSender, sx, theme]
  )

  return <StyledBox {...boxProps} sx={customStyle} />
}

export default MessageBox
